import { isDevelopment, isStaging } from '../../utils/environment'
export ZIndexes from './ZIndexes'

export const SVG_BASE_PATH = 'public/assets/svg/'
export const SVG_ICONS = `${SVG_BASE_PATH}icons/`
export const SVG_SHARE = `${SVG_BASE_PATH}social/share/`
export const SVG_REGISTRATION = `${SVG_BASE_PATH}registration/`

export const KEY_CODES = {
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    DOWN: 40,
    ESCAPE: 27,
    S: 83,
    X: 88,
    M: 77,
    A: 65,
    SPACE: 32,
}

export const MEDIA_SIZES = {
    thumb: 'thumb',
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
}

export const MEDIA_LOADING_STATUS = {
    loading: 'loading',
    loaded: 'loaded',
}

export const MEDIA_MODULE_TYPES = {
    PHOTOS: 'photos',
    VIDEOS: 'videos',
    PANOS: 'panoramas',
}

export const MEDIA_PROPS_LIST = [
    MEDIA_MODULE_TYPES.PANOS,
    MEDIA_MODULE_TYPES.PHOTOS,
    MEDIA_MODULE_TYPES.VIDEOS, //360 first
]

export const MEDIA_TYPES = {
    panorama: 'panorama',
    video: 'video',
    video360: '360 video',
    photo: 'photo',
}

export const VIDEO_TYPE = {
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    AWS: 'aws',
}

export const TABS = {
    panos: '360s',
    videos: 'videos',
    photos: 'photos',
}

export const NAV_BUTTON_TYPES = {
    HINT: 'hint',
    ARROW: 'arrow',
    LOOK: 'look',
}

export const ANALYTICS_ACTIONS = {
    POWEREDBY: 'poweredby',
}

export const STOP_ANALYTICS_INITIATED_BY = {
    next_button: 'Next_Button',
    prev_button: 'Prev_Button',
    scene_panel: 'Scene_Panel',
    nav_button: 'Nav_Button',
    keyboard: 'Keyboard',
    map: 'Map',
    first_stop: 'First_Stop',
}

export const TOUR_TYPES = {
    walkingtour: 'walkingtour',
    mediatour: 'mediatour',
    hybridtour: 'hybridtour',
}

export const SCREEN_SIZES = {
    size_1350: 1350,
    size_1024: 1024,
    size_945: 945,
}

export const PLATFORM = {
    desktop: 'desktop',
    mobile: 'mobile',
}

export const CUSTOM_MEDIA_LABELS = {
    BACK_TO_SCENE: 'Back to Scene',
    SKIP_INTRO: 'Skip Intro',
}

export const MIXPANEL_TOKEN =
    isDevelopment() || isStaging() ? '61602096566ec2c5f7e9da0c27f97607' : '29afd200f19c8c22f1ff99be1e79a99a'

export const KINESIS_TOKEN = '7187ef12-5f9b-4cd5-81aa-815df513519b'

export const SHARE_TYPES = {
    email: 'email',
    link: 'link',
    twitter: 'twitter',
    linkedin: 'linkedin',
    facebook: 'facebook',
}

export const TourActions = {
    RESET_TOUR_DATA: 'RESET_TOUR_DATA',
    SET_CLIENT: 'SET_CLIENT',

    SET_TOUR_EMBED_EXPANDED: 'SET_TOUR_EMBED_EXPANDED',

    SET_LOCATION: 'SET_LOCATION',
    SET_HOTSPOTS: 'SET_HOTSPOTS',

    GO_TO_POINT: '|A|GO_TO_POINT',
    NEXT_POINT: 'NEXT_POINT',
    PREV_POINT: 'PREV_POINT',

    SET_TRAIL: 'SET_TRAIL',
    SET_TRAILS_CACHE: 'SET_TRAILS_CACHE',

    SET_POINT: 'SET_POINT',
    SET_POINTS: 'SET_POINTS',

    STOP_CHANGED: '|A|STOP_CHANGED',
    SET_STOP: 'SET_STOP',
    SET_STOPS_CACHE: 'SET_STOPS_CACHE',
    SET_STOP_VISITED: 'SET_STOP_VISITED',
    CLEAR_VISITED_STOPS: 'CLEAR_VISITED_STOPS',

    SET_INSTITUTION: 'SET_INSTITUTION',
    SET_LOCATIONS: 'SET_LOCATIONS',

    SET_TOUR: 'SET_TOUR',
    SET_TOURS: 'SET_TOURS',

    SET_ACTION_BUTTONS: 'SET_ACTION_BUTTONS',

    LOADING: 'LOADING',
    ERROR: 'ERROR',

    TOUR_INITIALIZED_COMPLETE: 'TOUR_INITIALIZED_COMPLETE',

    LAUNCH_ADA_MODE: 'LAUNCH_ADA_MODE',

    SET_PANORAMA_PARAMS: 'SET_PANORAMA_PARAMS',

    SET_PLATFORM: 'SET_PLATFORM',
    SET_ORIGINAL_PLATFORM: 'SET_ORIGINAL_PLATFORM',
    SET_DISPLAY_SINGLE_STOP: 'SET_DISPLAY_SINGLE_STOP',

    SET_REGISTRATION_AUTOLAUNCH: 'SET_REGISTRATION_AUTOLAUNCH',
    SET_REGISTRATION_ENABLED: 'SET_REGISTRATION_ENABLED',
    SET_REGISTRATION_WELCOME_PROMPT: 'SET_REGISTRATION_WELCOME_PROMPT',
    SET_LANDSCAPE_PROMPT: 'SET_LANDSCAPE_PROMPT',

    SET_WELCOME_PROMPT: 'SET_WELCOME_PROMPT',

    SHOW_ALT_MEDIA: '|A|SHOW_ALT_MEDIA',

    SHOW_DESCRIPTION: 'SHOW_DESCRIPTION',

    MAIN_MEDIA_INITIALIZED: 'MAIN_MEDIA_INITIALIZED',
    MAIN_MEDIA_LOADING_STATUS: 'MAIN_MEDIA_LOADING_STATUS',
    MAIN_MEDIA_IS_STALLING: 'MAIN_MEDIA_IS_STALLING',
    MAIN_MEDIA_TYPE: 'MAIN_MEDIA_TYPE',
    SET_MAIN_MEDIA_DIMENSION: 'SET_MAIN_MEDIA_DIMENSION',
    SET_MAIN_MEDIA_PHOTO_PLAYER_BOUNDING_RECT: 'SET_MAIN_MEDIA_PHOTO_PLAYER_BOUNDING_RECT',

    TOUR_NAV_HINT_BUTTON: 'TOUR_NAV_HINT_BUTTON',
    SKIPPED_ALT_MAIN_MEDIA: '|A|SKIPPED_ALT_MAIN_MEDIA',

    SHOW_SKIP: 'SHOW_SKIP',
    FROM_VR: 'FROM_VR',

    IS_WINDOW_FULLSCREEN: '|A|IS_WINDOW_FULLSCREEN',

    SET_IS_STOP_INTRO_PLAYED: 'SET_IS_STOP_INTRO_PLAYED',

    USER_IS_IDLE: 'USER_IS_IDLE',

    IS_AUTO_PLAY_BLOCKED: 'IS_AUTO_PLAY_BLOCKED',
    IS_AUTO_PLAY_ENABLED: 'IS_AUTO_PLAY_ENABLED',

    SET_EXPERIENCE_UPDATED: 'SET_EXPERIENCE_UPDATED',
    SET_TOUR_TITLE: 'SET_TOUR_TITLE',
    SET_FONT_FACE: 'SET_FONT_FACE',
    SET_IS_EXPERIENCE_OFFLINE: 'SET_IS_EXPERIENCE_OFFLINE',
}
